import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { RoleNameInterface } from '../data/role-name.interface';

@Injectable()
export class RoleNameCacheRepository extends MemoryCacheRepository<RoleNameInterface[]> {}
